import React from 'react';

import * as S from './styles';

import functions from './functions';
import theme from '../../global/styles/theme';
import TextDefault from '../TextDefault';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';

function RenderTab(AllRoutes: any) {
  return AllRoutes();
}

function RenderBottomTab(
  route: any,
  index: number,
  options: any,
  state: any,
  navigation: any,
  appTheme: 'light' | 'dark',
) {
  const isFocus = state.index === index;
  const nameImage = functions.validationIcon(route);
  const nameRoute = functions.validationName(route);

  const NavigationTab = () => {
    const {name} = route;
    if (state.index !== index) {
      navigation.navigate(name);
    }
  };

  const renderIcon = () => {
    if (nameRoute !== 'Tokens') {
      return (
        <S.IconImageMaterialCommunityIcons
          color={
            isFocus
              ? theme.colors(appTheme).main[700]
              : theme.colors(appTheme).white
          }
          size={22}
          name={nameImage}
        />
      );
    }
    return (
      <S.IconImageMaterialIcons
        color={
          isFocus
            ? theme.colors(appTheme).main[700]
            : theme.colors(appTheme).white
        }
        size={22}
        name={nameImage}
      />
    );
  };

  return (
    <S.Button
      key={index}
      onPress={NavigationTab}
      style={{
        backgroundColor: theme.colors(appTheme).backgroundColor,
      }}>
      {renderIcon()}
      <TextDefault
        fontSize={10}
        marginTop={5}
        color={
          isFocus
            ? theme.colors(appTheme).main[700]
            : theme.colors(appTheme).white
        }
        text={nameRoute}
        fontFamily={theme.fonts.family.opensans.semi_bold}
        textAlign="center"
        numberOfLines={2}
      />
    </S.Button>
  );
}

export default function ContainerTab(props: any) {
  const {descriptors, navigation, state} = props;

  const appTheme = useSelector(
    (stateRoot: RootState) => stateRoot.config.appTheme,
  );

  // const [keyboardOpen, setKeyboardOpen] = useState(false);

  // useEffect(() => {
  //     const getHideKeyboard = Keyboard.addListener('keyboardDidHide', () => {
  //         setKeyboardOpen(false);
  //     });
  //     const getShowKeyboard = Keyboard.addListener('keyboardDidShow', () => {
  //         setKeyboardOpen(true);
  //     });

  //     return () => {
  //         getShowKeyboard.remove();
  //         getHideKeyboard.remove();
  //     };
  // }, []);

  function AllRoutes() {
    return state.routes.map((route: any, index: number) => {
      const {options} = descriptors[route.key];
      return RenderBottomTab(
        route,
        index,
        options,
        state,
        navigation,
        appTheme,
      );
    });
  }

  return (
    <S.TabArea appTheme={appTheme}>
      <S.Row>{RenderTab(AllRoutes)}</S.Row>
    </S.TabArea>
  );
}
